import {
  inject,
  Injectable,
  Injector,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { Settings } from '../models/settings/setting.model';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  platformId = inject(PLATFORM_ID);
  injector = inject(Injector);
  public setting = signal<Settings>(new Settings());

  private settings = new BehaviorSubject<Settings>(new Settings());
  currentSettings = this.settings.asObservable();

  updateSettings(settings: Settings) {
    this.setting.set(settings);
  }

  getMobileStatus() {
    if (isPlatformServer(this.platformId)) {
      return (
        (this.injector.get('IS_MOBILE' as any, null, { optional: true }) as
          | boolean
          | null) ?? false
      );
    }

    const ua = navigator.userAgent;

    if (
      /(iphone|android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm|phone|psp|symbian|treo|vodafone|wap|windows ce|xda|xiino/i.test(
        ua,
      )
    ) {
      return true;
    }
    return false;
  }

  getTabletStatus() {
    if (isPlatformServer(this.platformId)) {
      return (
        (this.injector.get('IS_TABLET' as any, null, { optional: true }) as
          | boolean
          | null) ?? false
      );
    }
    const ua = navigator.userAgent;

    if (ua.match(/Tablet|iPad|iPod/i)) {
      return true;
    }

    return false;
  }
}
